import React, { useState, useContext, useEffect } from 'react';

const Loading = () => {
    return (
        <div id="loadingstate">
            <div className="animation">
                <div className="anis">
                    <span className="won01"></span>
                    <span className="won02"></span>
                    <span className="won03"></span>
                </div>

                <div className="anis2">
                    <span className="won01"></span>
                    <span className="won02"></span>
                </div>
            </div>
        </div>
    )
};

export default Loading;